<template>
  <div class="item-inner specal" v-if="attribute.value.length >= 140"  style="margin-bottom: 7rem">
    <div class="item-title ">{{this.attribute.label}}</div>
    <div class="item-after">
      <textarea  rows="" cols=""  placeholder="请填写" style="font-size: .6rem;text-align: right;height:7rem"  v-if="attribute.sorteditAble === false || attribute.groupId === 1 || merchandises.categoryId !== 20"  :value='attribute.valueText' readonly="readonly"/>
      <textarea  rows="" cols="" type="text"  rows="" cols=""  @input="control"  placeholder="请填写"  style="font-size: .6rem;text-align: center; "  v-else   v-model="attribute.value"/>
    </div>
  </div>
  <div class="item-inner specal" v-else-if="attribute.value.length >= 100 && attribute.value.length < 140"  style="margin-bottom: 5rem">
    <div class="item-title ">{{this.attribute.label}}</div>
    <div class="item-after">
      <textarea  rows="" cols=""  placeholder="请填写" style="font-size: .6rem;text-align: right;height:7rem"  v-if="attribute.sorteditAble === false || attribute.groupId === 1 || merchandises.categoryId !== 20"  :value='attribute.valueText' readonly="readonly"/>
      <textarea  rows="" cols="" type="text"  rows="" cols=""  @input="control"  placeholder="请填写"  style="font-size: .6rem;text-align: center; "  v-else   v-model="attribute.value"/>
    </div>
  </div>
  <div class="item-inner specal" v-else-if="attribute.value.length > 40  && attribute.value.length < 100"  style="margin-bottom: 4rem">
    <div class="item-title ">{{this.attribute.label}}</div>
    <div class="item-after">
      <textarea  rows="" cols=""  placeholder="请填写" style="font-size: .6rem;text-align: right;"  v-if="attribute.sorteditAble === false || attribute.groupId === 1 || merchandises.categoryId !== 20"  :value='attribute.valueText' readonly="readonly"/>
      <textarea  rows="" cols="" type="text"  rows="" cols=""  @input="control"  placeholder="请填写"  style="font-size: .6rem;text-align: center; "  v-else   v-model="attribute.value"/>
    </div>
  </div>
  <div class="item-inner specal"  v-else style="margin-bottom: .5rem">
    <div class="item-title ">{{this.attribute.label}}</div>
    <div class="item-after">
      <textarea  rows="" cols=""  placeholder="请填写" style="font-size: .6rem;text-align: right;"  v-if="attribute.sorteditAble === false || attribute.groupId === 1 || merchandises.categoryId !== 20"  :value='attribute.valueText'  readonly="readonly"/>
      <textarea  rows="" cols="" type="text"  rows="" cols=""  @input="control"  placeholder="请填写"  style="font-size: .6rem;text-align: right; "  v-else   v-model="attribute.value"/>
    </div>
  </div>
  </div>

  <!--<div class="item-title label" v-if="attribute.sorteditAble === false" style="width: 60%; color: #8e8e93;" >{{this.attribute.label}}</div>-->
  <!--<div class="item-title label" v-else style="width: 60%;">{{this.attribute.label}}</div>-->
  <!--<div class="item-input">-->
  <!--<input type="text"  placeholder="请填写"  v-if="attribute.sorteditAble === false"  :value='attribute.value' disabled="disabled" >-->
  <!--<input type="text"   @input="control"  placeholder="请填写"   v-else   v-model="attribute.value">-->
  <!--</div>-->
  </div>
</template>

<script>
    //  import $ from 'jquery'
    export default {
      name: 'finder-attr-text-box',
      data () {
        return {
        }
      },
      props: [
        'attribute', 'index', 'curAttrsInGroup', 'merchandises'
      ],
      mounted () {
      },
      created () {

      },
      computed: {
      },
      methods: {
        control () {
          this.$emit('controlForm', this.index, this.curAttrsInGroup)
        }
      },
      watch: {
        'attribute.value': function (val) {
          this.attribute.valueText = val
        }
      }
    }
</script>

<style scoped>
  .specal {
    border-bottom: 0px solid;
  }
  .checkbox-el {
    display: inline-block;
    text-align: left;
  }
  .options {
    color: grey;
    font-size: .6rem;
    width: 120px;
    margin-left: .3rem;
  }
  .item-content {
    padding-left: .2rem
  }
  .item-title {
    font-size: 0.6rem;
    color: black;
  }
  .guding {
    width: 140px;
  }
  .item-after {
    font-size: 0.6rem;
    color: black;
    width: 200px;
    text-align: right;
  }
  .gotopay{
    position: absolute;
    right: 0;
    background-color: #00469A;
  @include wh(5rem, 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5rem;
    height: 3rem;}
  .gotopay_button_style{
  @include sc(.7rem, #F6383A);
    font-weight: bold;
    color: #fff;

  }
  .button.active {
    z-index: 100;
    color: #00469A;
    background-color: white;
    border-bottom: 1px solid
  }
  .tab-link.button {
    border: 0px solid black;
    color: gray;
    border-radius: 0;
  }
</style>



// WEBPACK FOOTER //
// FinderAttrTextBox.vue?f19c4368